export interface ModelOption {
  /** Selector value. Same string the backend stores. */
  value: string;
  label: string;
  /** Sent as `model_version`. */
  modelVersion: "4.5" | "5.5";
}

// Hardcoded until the backend exposes the list of selectable models.
export const MODEL_OPTIONS: ModelOption[] = [
  { value: "4.5", label: "4.5 models", modelVersion: "4.5" },
  { value: "5.5", label: "5.5 models", modelVersion: "5.5" },
];

/** A new chat, and a chat with no stored version, follow the environment rollout. */
export const DEFAULT_MODEL = "5.5";

/** Maps a backend `model_version` to a selector value. Null and unknown
 * versions follow the rollout, which is what the server does with them. */
export const fromModelVersion = (modelVersion: string | null | undefined): string =>
  MODEL_OPTIONS.find((option) => option.modelVersion === modelVersion)?.value ??
  DEFAULT_MODEL;

/** Maps a selector value to the `model_version` sent to the backend. */
export const toModelVersion = (value: string): string | null =>
  MODEL_OPTIONS.find((option) => option.value === value)?.modelVersion ?? null;
